export default __webpack_public_path__ + "static/media/KOD0058-min.2e1a867a.webp";